import { useState } from "react";
import axios from "axios";
import logo from "../assets/buraq_logo.jpg";
import { Link, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { BASE_URL } from "../constants";

const PRODUCT_OPTIONS = [
  "Electrical Products",
  "Lighting Solutions",
  "Ventilation Solutions",
  "Water & Plumbing Solutions",
  "Sanitary Products",
  "Power Tools & Hardware",
  "Gardening Tools",
];

const CUSTOMER_TYPES = [
  "Contractor / Installer",
  "Trading Company ",
  "Retailer / Showroom",
  "Project Owner / Deveoper",
  "Consultant / Engineer",
  "Facility Management Comapany",
  "LandScaping / Gardening",
  "Government / Organization",
  "Landscaping Company",
  "Other business type",
];

const VOLUME_OPTIONS = [
  { value: "<5000", label: "Less than AED 5,000" },
  { value: "5000-20000", label: "AED 5,000 – 20,000" },
  { value: "20000-50000", label: "AED 20,000 – 50,000" },
  { value: "50000-100000", label: "AED 50,000 – 100,000" },
  { value: ">100000", label: "More than AED 100,000" },
];

export default function BuraqStarTradePage() {
    const location = useLocation();
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    whatsapp: "",
    email: "",
    customerType: "",
    volume: "",
    notes: "",
  });
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogoClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
    }
  };

  const toggleProduct = (value) => {
    setSelectedProducts((prev) =>
      prev.includes(value)
        ? prev.filter((p) => p !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (selectedProducts.length === 0) {
    alert("Please select at least one product category.");
    return;
  }

  const payload = {
    full_name: formData.fullName,
    company: formData.company,
    whatsapp: formData.whatsapp,
    email: formData.email,
    customer_type: formData.customerType,
    products: selectedProducts,
    volume: formData.volume,
    notes: formData.notes,
  };

  setSubmitting(true);

  try {
    await axios.post(`${BASE_URL}/api/v1/product-quote-request`, payload);
    setSubmitted(true);

    // Meta Pixel: track successful wholesale enquiry
    if (window.fbq) {
      window.fbq("track", "Lead", {
        content_name: "Wholesale Quote Request",
        content_category: formData.customerType || "B2B",
      });
    }
  } catch (error) {
    console.error("Quote submission failed:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setSubmitting(false);
  }
};

  return (
    <>
      <style>{`
        :root{
          --navy-deep:#0F1B2D;
          --navy-mid:#16273E;
          --steel:#5C7089;
          --steel-light:#AEB9C7;
          --amber:#E8871E;
          --amber-dark:#C46F12;
          --off-white:#F5F6F8;
          --white:#FFFFFF;
          --line:#E1E5EA;
          --success:#2F9E44;
          --form-bg:#EAF7FF;
          --slate-border:#475569;
          --charcoal:#36454F;
          --royal-blue:#003B73;
          --royal-blue-dark:#1A3FAE;
          --muted-slate:#6B7C8C;
        }
        *{box-sizing:border-box;margin:0;padding:0;}
        html{scroll-behavior:smooth;}
        body{
          font-family:'IBM Plex Sans', sans-serif;
          background:var(--off-white);
          color:var(--navy-deep);
          line-height:1.5;
        }
        h1,h2,h3{font-family:'Space Grotesk', sans-serif;}
        a{color:inherit;}

        /* ---------- top strip ---------- */
        .draft-ribbon{
          background:repeating-linear-gradient(135deg, var(--amber), var(--amber) 10px, var(--navy-deep) 10px, var(--navy-deep) 20px);
          color:var(--white);
          text-align:center;
          font-family:'IBM Plex Mono', monospace;
          font-size:12px;
          letter-spacing:.08em;
          padding:6px 0;
        }
        .draft-ribbon span{
          background:var(--navy-deep);
          padding:2px 12px;
          display:inline-block;
        }

        /* ---------- nav ---------- */
        header{
          background:var(--white);
          color:var(--navy-deep);
          padding:14px 6vw;
          display:flex;
          justify-content:space-between;
          align-items:center;
          flex-wrap:wrap;
          gap:10px;
          border-bottom:4px solid var(--amber);
        }
        .logo img{
          height:44px;
          display:block;
        }
        .nav-contact{
          font-family:'IBM Plex Mono', monospace;
          font-size:13px;
          color:var(--steel);
          display:flex;
          gap:22px;
          flex-wrap:wrap;
        }

        /* ---------- hero ---------- */
        .hero{
          background:var(--navy-deep);
          color:var(--white);
          padding:56px 6vw 90px;
          display:grid;
          grid-template-columns:1.05fr 0.95fr;
          gap:56px;
          position:relative;
          overflow:hidden;
        }
        .hero::before{
          content:"";
          position:absolute;
          right:-120px; top:-120px;
          width:420px;height:420px;
          border:1px solid rgba(255,255,255,.06);
          border-radius:50%;
        }
        .hero::after{
          content:"";
          position:absolute;
          right:-60px; top:-60px;
          width:420px;height:420px;
          border:1px solid rgba(255,255,255,.06);
          border-radius:50%;
        }
        .eyebrow{
          font-family:'IBM Plex Mono', monospace;
          font-size:12px;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--amber);
          display:flex;
          align-items:center;
          gap:10px;
          margin-bottom:18px;
        }
        .eyebrow::before{
          content:"";
          width:26px;height:2px;
          background:var(--amber);
          display:inline-block;
        }
        .hero h1{
          font-size:clamp(32px, 4vw, 46px);
          font-weight:700;
          line-height:1.12;
          max-width:640px;
          margin-bottom:20px;
        }
        .hero h1 em{
          font-style:normal;
          color:var(--amber);
        }
        .hero p.lead{
          font-size:16px;
          color:var(--steel-light);
          max-width:520px;
          margin-bottom:34px;
        }
        .hazard-bar{
          height:6px;
          width:100%;
          max-width:420px;
          background:repeating-linear-gradient(-45deg, var(--amber), var(--amber) 10px, var(--navy-mid) 10px, var(--navy-mid) 20px);
          margin-bottom:34px;
          border-radius:2px;
        }
        .stat-strip{
          display:flex;
          gap:36px;
          flex-wrap:wrap;
          border-top:1px solid rgba(255,255,255,.12);
          padding-top:26px;
        }
        .stat-strip div{min-width:110px;}
        .stat-strip .num{
          font-family:'Space Grotesk', sans-serif;
          font-size:26px;
          font-weight:700;
          color:var(--white);
        }
        .stat-strip .label{
          font-family:'IBM Plex Mono', monospace;
          font-size:11.5px;
          color:var(--steel-light);
          letter-spacing:.04em;
          text-transform:uppercase;
        }

        /* ---------- form card ---------- */
        .form-wrap{position:relative;}
        .form-card{
          background:var(--form-bg);
          color:var(--charcoal);
          border-radius:4px;
          padding:34px 32px 30px;
          position:relative;
          box-shadow:0 30px 60px -20px rgba(0,0,0,.45);
        }
        .form-card::before,
        .form-card::after{
          content:"";
          position:absolute;
          width:22px;height:22px;
          border-color:var(--amber);
          border-style:solid;
        }
        .form-card::before{top:-8px;left:-8px;border-width:3px 0 0 3px;}
        .form-card::after{bottom:-8px;right:-8px;border-width:0 3px 3px 0;}

        .form-head{
          padding-bottom:6px;
        }
        .form-head h2{
          font-size:20px;
          font-weight:700;
        }
        .form-sub{
          font-size:13px;
          color:var(--steel);
          padding-bottom:16px;
          border-bottom:1px dashed var(--line);
          margin-bottom:22px;
        }

        .field{margin-bottom:16px;}
        .field label{
          display:block;
          font-family:'IBM Plex Mono', monospace;
          font-size:11.5px;
          text-transform:uppercase;
          letter-spacing:.05em;
          color:var(--charcoal);
          margin-bottom:6px;
        }
        .field label .req{color:var(--royal-blue);}
        .field label .opt{
          color:var(--steel-light);
          text-transform:none;
          font-weight:400;
          letter-spacing:0;
        }
        .field input[type="text"],
        .field input[type="email"],
        .field input[type="tel"],
        .field select,
        .field textarea{
          width:100%;
          padding:11px 12px;
          border:1px solid var(--slate-border);
          border-radius:3px;
          font-family:'IBM Plex Sans', sans-serif;
          font-size:14.5px;
          color:var(--charcoal);
          background:var(--white);
          transition:border-color .15s, background .15s;
        }
        .field textarea{
          resize:vertical;
          min-height:88px;
        }
        .field input:focus,
        .field select:focus,
        .field textarea:focus{
          outline:none;
          border-color:var(--royal-blue);
          background:var(--white);
        }
        .two-col{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:14px;
        }

        .chip-group{
          display:flex;
          flex-wrap:wrap;
          gap:8px;
        }
        .chip{
          position:relative;
        }
        .chip input{
          position:absolute;
          opacity:0;
          width:100%;height:100%;
          cursor:pointer;
          margin:0;
        }
        .chip span{
          display:inline-block;
          padding:8px 13px;
          border:1px solid var(--line);
          border-radius:20px;
          font-size:13px;
          color:var(--navy-mid);
          background:var(--off-white);
          transition:all .15s;
        }
        .chip input:checked + span{
          background:var(--navy-deep);
          border-color:var(--navy-deep);
          color:var(--white);
        }
        .chip input:focus-visible + span{
          outline:2px solid var(--amber);
          outline-offset:1px;
        }

        .submit-btn{
          width:100%;
          margin-top:6px;
          padding:15px 0;
          background:var(--royal-blue);
          color:var(--white);
          border:none;
          border-radius:3px;
          font-family:'Space Grotesk', sans-serif;
          font-weight:700;
          font-size:15px;
          letter-spacing:.01em;
          cursor:pointer;
          position:relative;
          transition:background .15s, transform .1s;
        }
        .submit-btn:hover{background:var(--royal-blue-dark);}
        .submit-btn:active{transform:translateY(1px);}
        .submit-btn:disabled{
          background:var(--steel);
          cursor:not-allowed;
        }

        .trust-row{
          max-width:340px;
          margin:12px auto 0;
          text-align:center;
          font-size:11px;
          line-height:1.5;
          color:var(--muted-slate);
          font-family:'IBM Plex Mono', monospace;
        }

        .success-state{
          display:none;
          text-align:center;
          padding:30px 10px 10px;
        }
        .success-state.is-visible{display:block;}
        .success-state .check{
          width:52px;height:52px;
          border-radius:50%;
          background:var(--success);
          color:var(--white);
          display:flex;
          align-items:center;
          justify-content:center;
          margin:0 auto 16px;
          font-size:26px;
        }
        .success-state h3{font-size:18px; margin-bottom:8px;}
        .success-state p{font-size:13.5px; color:var(--steel); margin-bottom:22px;}
        .explore-btn{
          display:inline-block;
          padding:13px 26px;
          background:var(--navy-deep);
          color:var(--white);
          text-decoration:none;
          border-radius:3px;
          font-family:'Space Grotesk', sans-serif;
          font-weight:600;
          font-size:14px;
          transition:background .15s, transform .1s;
        }
        .explore-btn:hover{background:var(--navy-mid);}
        .explore-btn:active{transform:translateY(1px);}

        /* ---------- benefits ---------- */
        .benefits{
          padding:70px 6vw;
          background:var(--white);
        }
        .benefits-head{
          max-width:560px;
          margin:0 auto 44px;
          text-align:center;
        }
        .benefits-head .eyebrow{color:var(--amber-dark); justify-content:center;}
        .benefits-head .eyebrow::before{display:none;}
        .benefits-head h2{
          font-size:clamp(24px,3vw,32px);
          font-weight:700;
          color:var(--navy-deep);
        }
        .benefit-grid{
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:28px;
          max-width:1080px;
          margin:0 auto;
        }
        .benefit-card{
          border:1px solid var(--line);
          border-top:3px solid var(--amber);
          padding:26px 22px;
          border-radius:3px;
        }
        .benefit-card .idx{
          font-family:'IBM Plex Mono', monospace;
          font-size:12px;
          color:var(--steel);
          margin-bottom:12px;
        }
        .benefit-card h3{font-size:17px; margin-bottom:8px; color:var(--navy-deep);}
        .benefit-card p{font-size:13.5px; color:var(--steel);}

        /* ---------- footer ---------- */
        footer{
          background:var(--navy-deep);
          color:var(--steel-light);
          padding:26px 6vw;
          font-size:12.5px;
          display:flex;
          justify-content:space-between;
          flex-wrap:wrap;
          gap:10px;
          font-family:'IBM Plex Mono', monospace;
        }

        /* ---------- floating quick-assist button ---------- */
        .fab-chat{
          position:fixed;
          right:24px;
          bottom:24px;
          z-index:999;
          display:flex;
          align-items:center;
          gap:10px;
          background:var(--navy-deep);
          color:var(--white);
          border:1px solid rgba(255,255,255,.08);
          padding:13px 18px 13px 14px;
          border-radius:32px;
          text-decoration:none;
          box-shadow:0 12px 28px -10px rgba(15,27,45,.55);
          font-family:'Space Grotesk', sans-serif;
          font-weight:600;
          font-size:14px;
          transition:background .18s, transform .15s, box-shadow .18s;
        }
        .fab-chat:hover{
          background:var(--navy-mid);
          transform:translateY(-2px);
          box-shadow:0 16px 32px -10px rgba(15,27,45,.6);
        }
        .fab-chat:active{transform:translateY(0);}
        .fab-chat .fab-icon{
          width:36px;
          height:36px;
          flex:0 0 auto;
          border-radius:50%;
          background:var(--amber);
          display:flex;
          align-items:center;
          justify-content:center;
          color:var(--navy-deep);
        }
        .fab-chat .fab-icon svg{width:18px;height:18px;}
        .fab-chat .fab-text{
          display:flex;
          flex-direction:column;
          line-height:1.2;
        }
        .fab-chat .fab-text .fab-label{font-size:13.5px;}
        .fab-chat .fab-text .fab-sub{
          font-family:'IBM Plex Mono', monospace;
          font-size:10.5px;
          font-weight:400;
          color:var(--steel-light);
          letter-spacing:.02em;
        }
        .fab-chat .fab-dot{
          position:absolute;
          top:10px;
          left:32px;
          width:9px;
          height:9px;
          border-radius:50%;
          background:var(--success);
          border:2px solid var(--navy-deep);
        }

        @media (max-width:560px){
          .fab-chat .fab-text{display:none;}
          .fab-chat{
            padding:14px;
            border-radius:50%;
          }
          .fab-chat .fab-icon{width:26px;height:26px;}
          .fab-chat .fab-dot{top:6px;left:6px;}
        }

        @media (max-width:880px){
          .hero{grid-template-columns:1fr; padding:44px 6vw 60px;}
          .benefit-grid{grid-template-columns:1fr;}
          .two-col{grid-template-columns:1fr;}
          .stat-strip{gap:24px;}
        }
      `}</style>

      <div className="draft-ribbon">
        {"  "}
        <span>BURAQ STAR TRADE ACCOUNT — WHOLESALE ENQUIRY</span>
      </div>

      <header>
        <div className="logo">
          {!logoError && (
                   <Link to="/" onClick={handleLogoClick}>
          <Box
            component="img"
            src={logo}
            alt="burraq star logo"
            sx={{
              height: { xs: 30, sm: 38, md: 44, lg: 45 },
              width: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Link>
          )}
        </div>
        <div className="nav-contact">
          <span>Trade Desk: +971 56 547 1232</span>
          <span>ecommerce@buraqstar.com</span>
        </div>
      </header>

      <section className="hero">
        <div className="hero-copy">
          <div className="eyebrow">Wholesale Supply · UAE</div>
          <h1>
            Trade Pricing on Electrical, Sanitary &amp; Hardware —{" "}
            <em>No Retail Markup.</em>
          </h1>
          <p className="lead">
            Buraq Star supplies contractors, retailers and facility teams
            across the UAE from stock. Tell us what you need below and our
            trade desk will send pricing within one business day.
          </p>
          <div className="hazard-bar"></div>
          <div className="stat-strip">
            <div>
              <div className="num">5,000+</div>
              <div className="label">SKUs in stock</div>
            </div>
            <div>
              <div className="num">48H</div>
              <div className="label">Dispatch time</div>
            </div>
            <div>
              <div className="num">UAE-wide</div>
              <div className="label">Bulk delivery</div>
            </div>
          </div>
        </div>

        <div className="form-wrap">
          <div className="form-card">
            <div className="form-head">
              <h2>Request Product Quote</h2>
            </div>
            <p className="form-sub">
              Get pricing, availability and product support from our sales
              team.
            </p>

            {!submitted && (
              <form id="tradeForm" onSubmit={handleSubmit}>
                <div className="two-col">
                  <div className="field">
                    <label htmlFor="fullName">
                      Full Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      placeholder="Your name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="field">
                    <label htmlFor="company">
                      Company Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      placeholder="e.g. Al Noor Contracting LLC"
                      value={formData.company}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="two-col">
                  <div className="field">
                    <label htmlFor="whatsapp">
                      WhatsApp Number <span className="req">*</span>
                    </label>
                   <input
                      type="tel"
                      id="whatsapp"
                      name="whatsapp"
                      placeholder="+971 5X XXX XXXX"
                      value={formData.whatsapp}
                      onChange={handleChange}
                      required
                      inputMode="numeric"
                      pattern="^\+?[0-9\s\-()]{7,20}$"
                      title="Enter a valid UAE mobile number"
                    />
                  </div>
                  <div className="field poppins">
                    <label htmlFor="email">
                      Email Address <span className="opt">(Optional)</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="name@company.com"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="customerType">
                    Customer Type <span className="req">*</span>
                  </label>
                  <select
                    id="customerType"
                    name="customerType"
                    value={formData.customerType}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Select Business Type
                    </option>
                    {CUSTOMER_TYPES.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field">
                  <label>
                    Product Category <span className="req">*</span>
                  </label>
                  <div className="chip-group" id="productChips">
                    {PRODUCT_OPTIONS.map((product) => (
                      <label className="chip" key={product}>
                        <input
                          type="checkbox"
                          name="products"
                          value={product}
                          checked={selectedProducts.includes(product)}
                          onChange={() => toggleProduct(product)}
                        />
                        <span>{product}</span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="volume">
                    Monthly Purchase Requirement <span className="req">*</span>
                  </label>
                  <select
                    id="volume"
                    name="volume"
                    value={formData.volume}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>
                      Select Volume
                    </option>
                    {VOLUME_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field">
                  <label htmlFor="notes">
                    Product Requirements <span className="opt">(Optional)</span>
                  </label>
                  <textarea
                    id="notes"
                    name="notes"
                    rows="4"
                    placeholder="Tell us more about what you need…"
                    value={formData.notes}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn" disabled={submitting}>
                  {submitting ? "Submitting…" : "Request Product Quote →"}
                </button>
                <div className="trust-row">
                  <span className="poppins">
                    Your enquiry helps us understand your requirements and
                    provide the right product solutions.
                  </span>
                </div>
              </form>
            )}

            <div
              className={`success-state${submitted ? " is-visible" : ""}`}
              id="successState"
            >
              <div className="check">✓</div>
              <h3 >Request received</h3>
              <p >
                Our trade desk will call or email you within one business day
                with pricing for your selected products.
              </p>
              <a
                href="https://buraqstar.com/"
               
                className="explore-btn"
              >
                Explore Our Website →
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="benefits">
        <div className="benefits-head">
          <div className="eyebrow">Why buyers stock with us</div>
          <h2>Built for repeat, bulk purchasing</h2>
        </div>
        <div className="benefit-grid">
          <div className="benefit-card">
            <div className="idx">01 / STOCK</div>
            <h3>Deep inventory, ready to move</h3>
            <p>
              Electrical, sanitary and hardware lines held in bulk across our
              UAE warehouses — no waiting on factory lead times.
            </p>
          </div>
          <div className="benefit-card">
            <div className="idx">02 / PRICING</div>
            <h3>Direct trade pricing</h3>
            <p>
              No middleman markup. Pricing scales with your monthly volume,
              reviewed as your account grows.
            </p>
          </div>
          <div className="benefit-card">
            <div className="idx">03 / DELIVERY</div>
            <h3>Fast, reliable dispatch</h3>
            <p>
              Orders above the free-delivery threshold ship across the UAE
              within 48 hours of confirmation.
            </p>
          </div>
        </div>
      </section>

      <footer>
        <span>© Buraq Star Trading LLC — Wholesale Division</span>
        <span>Electrical · Sanitary · Hardware · UAE-Wide Delivery</span>
      </footer>

      <a
        href="https://wa.me/971565471232?text=Hi%2C%20I%27d%20like%20some%20quick%20assistance%20with%20a%20wholesale%20order."
        target="_blank"
        rel="noopener noreferrer"
        className="fab-chat"
        aria-label="Chat with our trade desk on WhatsApp"
      >
        <span className="fab-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 3C7.03 3 3 6.94 3 11.8c0 1.72.5 3.32 1.36 4.68L3 21l4.64-1.32A9.2 9.2 0 0 0 12 20.6c4.97 0 9-3.94 9-8.8S16.97 3 12 3Z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M8.7 8.9c.15-.35.3-.36.44-.36.1 0 .27 0 .4.02.16.03.36-.06.55.42.2.5.68 1.72.74 1.85.06.13.1.28.02.45-.08.17-.13.28-.26.43-.13.15-.27.34-.39.46-.13.13-.26.27-.11.53.15.26.65 1.07 1.4 1.73.96.85 1.77 1.11 2.03 1.24.26.13.41.11.56-.07.15-.18.65-.75.82-1.01.17-.26.34-.22.56-.13.23.09 1.44.68 1.69.8.24.13.4.19.46.3.06.11.06.63-.15 1.24-.2.61-1.19 1.17-1.66 1.24-.42.06-.95.09-1.53-.1-.35-.11-.8-.26-1.38-.51-2.43-1.05-4.02-3.5-4.15-3.66-.12-.17-1-1.33-1-2.53 0-1.2.63-1.79.85-2.03Z"
              fill="currentColor"
            />
          </svg>
        </span>
        <span className="fab-dot"></span>
        <span className="fab-text">
          <span className="fab-label">Quick Assistance</span>
        </span>
      </a>
    </>
  );
}
